<template>
  <div class="layout">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <searchBar @search="openSearch = true" :placeholder="placeholder" :theme="1"></searchBar>
    <div class="ex_page">
      <div class="ex_left">
        <div class="active_wrap">
          <div class="active_list" v-if="navList.length">
            <div class="active_item" :class="{ is_active: index == activeKey }" @click="activeChange(index)" v-for="(item, index) in navList" :key="item.id">
              <span class="item_text">{{ item.nameEn }}</span>
            </div>
          </div>
        </div>
        <!-- <van-sidebar class="active_list" v-model="activeKey" @change="activeChange">
          <van-sidebar-item v-for="(item,index) in navList" :key="index" :title="item.name" />
        </van-sidebar>-->
      </div>
      <div class="ex_right" v-if="navList.length">
        <div class="title">
          <van-swipe class="pro_title_swipe" v-if="titleBanner && titleBanner.length" :autoplay="4000" :show-indicators="false">
            <van-swipe-item v-for="(item, ind) in titleBanner" :key="ind">
              <template v-if="item.url">
                <a :href="item.url">
                  <img v-if="item && item.covers" :src="item.covers" v-load="'oProType'" />
                  <img v-else-if="showDefaultBanner" src="../../../static/images/ex_title.jpg" />
                </a>
              </template>
              <template v-else>
                <img v-if="item && item.covers" :src="item.covers" v-load="'oProType'" />
                <img v-else-if="showDefaultBanner" src="../../../static/images/ex_title.jpg" />
              </template>
            </van-swipe-item>
          </van-swipe>
          <div v-else-if="showDefaultBanner">
            <img src="../../../static/images/ex_title.jpg" />
            <p>{{ navList[activeKey].nameEn }}</p>
          </div>
        </div>
        <div class="type_nav">
          <van-button class="all_btn" @click="allClick(true)" :class="allActive ? 'is_active' : ''">All</van-button>
          <van-button class="dropdownbtn" @click="classClick" :class="{ is_active: isClassAll || classVals.length > 0, xiala: classShow }">Category</van-button>
          <van-button class="dropdownbtn" @click="areaClick" :class="{ is_active: (!allActive && areaVals.length > 0) || getAllActiveState(), xiala: areaShow }">Region</van-button>
          <div class="pop_mask" v-if="classShow" @click="classShow = false"></div>
          <div class="pop_mask" v-if="areaShow" @click="areaShow = false"></div>
          <div class="pop_block" v-show="isPopShow">
            <van-popup v-model="classShow" @open="isPopShow = true" @close="isPopShow = false" duration="0" position="top" class="drop_pop" overlay-class="pop_overlay" :get-container="getDomPop">
              <div class="class_con">
                <div class="class_item" :class="{ is_active: isClassAll }" v-if="activeKey" @click="classAllClick">All</div>
                <van-checkbox-group v-model="classVals">
                  <van-checkbox class="class_item" v-for="(item, index) in classOption" @click="classChange(item.id)" :key="index" :name="item.id">{{ item.nameEn  }}</van-checkbox>
                </van-checkbox-group>
              </div>
            </van-popup>

            <van-popup v-model="areaShow" @open="isPopShow = true" @close="isPopShow = false" duration="0" position="top" class="drop_pop" overlay-class="pop_overlay" :get-container="getDomPop">
              <van-checkbox-group v-model="areaVals">
                <div class="area_con" v-for="(item, index) in areaOption" :key="index">
                  <p style="font-weight:bold">{{ item.nameEn }}</p>
                  <div class="area_item_warp">
                    <div class="area_item" :class="{ is_active: isAreaAll[index] }" @click="areaAllClick(index)">All</div>
                    <van-checkbox class="area_item" v-for="(mode, ind) in item.lists" @click="areaItemClick(index)" :key="ind" :name="mode.id">{{ mode.nameEn }}</van-checkbox>
                    <!-- <div class="area_item" :class="{'is-active':areaVal===mode.value}" @click="areaChange(mode.value)" v-for="(mode,ind) in item.lists" :key="ind">{{mode.name}}</div> -->
                  </div>
                </div>
              </van-checkbox-group>
            </van-popup>
          </div>
        </div>

        <van-list class="ex_content" v-model="dataLoading" :finished="dataFinished" finished-text="It's the end~" @load="loadMore()">
          <div class="ex_con_wrap">
            <div class="ex_item" v-for="(item, index) in dataList" :key="index" @click="goLinkProduct(item.id, item.exhibitorId)">
              <div class="img_div">
                <div class="img-d" v-if="item.view3DUrl">
                  <i class="iconfont icon-d"></i>
                  <span>3D</span>
                </div>
                <!--全景 -->
                <div class="img-v" v-if="item.panoramaUrl">
                  <i class="iconfont icon-VR1"></i>
                </div>
                <div class="play_video" v-if="item.video && JSON.parse(item.video).url">
                  <i class="iconfont icon-zhibo"></i>
                </div>
                <template v-if="item.video && JSON.parse(item.video).url">
                  <img :src="JSON.parse(item.video).cover" v-if="JSON.parse(item.video).cover" />
                  <img v-else src="@/assets/img/empty.png" />
                </template>
                <template v-else>
                  <img :src="JSON.parse(item.banner)[0]" v-if="JSON.parse(item.banner)[0]" v-load="'oProSmall'" />
                  <img v-else src="@/assets/img/empty.png" />
                </template>
              </div>
              <div class="pro_info">
                <div class="pro_title">
                  <p class="van-multi-ellipsis--l2">{{ item.name }}</p>
                  <!-- <div class="is_live" v-if="item.exhibitor.isLiving">
                  <span></span>
                  直播中
                </div> -->
                  <div class="is_live is_hot" v-if="item.isPopularize">
                    <i class="icon iconfont icon-huo"></i>
                    Hot list
                  </div>
                </div>
                <p class="van-ellipsis comp_name">{{ item.exhibitor.company.nameEn || "" }}</p>
                <!-- <p v-if="item.selling" class="van-multi-ellipsis--l2 selling">{{item.sellingEn||item.selling}}</p> -->
                <!-- <div class="bus" v-for="(mode,i) in item.exhibitor.businesses" :key="i">
                <p class="van-ellipsis" :class="{is_sa:mode.isSample}" v-if="mode.remark">{{mode.remark}}</p>
                <span v-if="mode.isSample" @click.stop="openInquiry(item)" class="link_span">马上申请</span>
              </div> -->
                <!-- <div class="eval" v-if="item.newestEvaluates&&item.newestEvaluates.length">
                <span>最新评价：</span>{{item.newestEvaluates[0].content}}
              </div> -->
                <!-- <div class="likes_div" v-if="item.likes&&item.likes.length">
                <div class="avatar_img">
                  <div v-for="(avaItem,i) in item.likes" :key="i">
                    <img class="img"  v-if="avaItem.userInfo.avatarUrl" :src="avaItem.userInfo.avatarUrl" >
                    <span class="flag-icon img" v-else-if="avaItem.userInfo.flagStyle" :class="'flag-icon-'+avaItem.userInfo.flagStyle" :key="index"></span>
                    <img class="img" v-else src="@/assets/img/empty.png" >
                  </div>
                </div>
                <p :class="'ava_count'+item.likes.length">{{item.likeCount}}&nbsp;like(s)</p>
              </div> -->
              </div>
            </div>
          </div>

          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            Loading...
          </div>
          <div slot="finished" class="f-tac loading">
            It's the end~
          </div>
        </van-list>
        <!-- <div class="f-tac" style="line-height: 80px" v-else-if="!dataList.length">No data</div> -->
      </div>
    </div>
    <layoutFooter></layoutFooter>
    <!-- 索取样品 -->
    <inquiry ref="inquiry"></inquiry>
    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>
    <!-- 侧边栏 -->
    <exTool :isZT="false" :isZX="false"></exTool>
  </div>
</template>

<script>
import gql from "graphql-tag";
import searchBar from "@components/searchBar/index";
import commNotRegMask from "@/components/comm-notreg-mask";
import layoutFooter from "@components/layout-footer";
import regionData from "@/assets/js/region.json"; //地区json
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import searchPage from "@/components/searchPage"; // 搜索页
import inquiry from "@/components/inquiry/index";
import exTool from "../home/components/ex-tool";

export default {
  name: "exhibition",
  components: {
    searchBar,
    layoutFooter,
    searchPage,
    exTool,
    inquiry,
    // commNotRegMaskarrJson
  },
  data() {
    return {
      banners: {}, //banner接口
      titleBanner: [], //title背景
      allBanner: [], //全部展品时得banners数组
      showDefaultBanner: false,
      activeKey: 0, // 侧边导航 index
      navList: [],
      classVals: [], //类别value
      areaVals: [], //地区value
      allActive: true, //全部选择 默认全部:all   全部状态下，
      classShow: false, //类别选择弹出框
      areaShow: false, //地区选择弹出框
      isPopShow: false, //弹出层是否显示 ：控制z-index 动画效果需要
      isClassAll: false, //类别选择是否全选
      isAreaAll: [false, false, false], //地区index 0全选(国际)地区index 1全选(中国大陆)地区index 2全选(港澳台)
      //类别数组
      classOption: [],
      //地区数组
      areaOption: [],
      dataList: [], //产品数据数组
      dataLoading: true, //数据加载状态
      dataFinished: false, //数据加载是否完成
      pageIndex: 1,
      pageSize: 16,
      datalist: {},
      productList: "",
      hasNextPage: true, //是否还有下一页
      reMarkList: [], //展商信息列表 根据展会查询 拿到里面的remark字段（招商滚动信息）
      options: {
        categories: [],
        regions: [],
        name: "",
        text: "",
      },
      getProduct: {
        item: {},
      },
      docTitle: "Products",
      placeholder: "Products",
      openSearch: false, // 控制搜索组件
      rankingType: "Product", // 展品搜索
      searchType: 0, // 搜索类型
      newareaList: [],
      shareV: {
        content: "",
        poster: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    $(() => {
      $("body").addClass("fixed_body");
      $("html").addClass("fixed_body");
    });
  },
  beforeDestroy() {
    $("body").removeClass("fixed_body");
    $("html").removeClass("fixed_body");
  },
  watch: {
    search: function() {
      const txt = this.search.trim();
      console.log(txt, "txttxt");
      if (txt) {
        this.options = {
          // 输入框
          text: `${txt}`,
        };
      } else {
        this.options = {
          categories: [],
          regions: "",
          name: "",
          text: "",
        };
      }
      console.log(this.options, "搜索的结果");
      this.finished = false; //关闭加载结束
      this.pageIndex = 1;
      this.dataList = [];
      this.getProductList();
    },
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId",
      userInfo: "getUserInfo", //观众信息
      role: "getRole", //用户身份 0 游客
      hostInfo: "getHostInfo",
      category: "getCategory",
      exhibitionInfo: "getExhibitionInfo",
      search: "getSearch",
    }),
  },
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
      LinkExhibitionDetails: "linkTo/LinkExhibitionDetails",
      getUser: "login/getUser",
      LinkExInvitation: "linkTo/LinkExInvitation", //跳转到邀请函
      shareToWechat: "wxShare/shareToWechat",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      graphqlPostByZXS: "en/graphqlPostByZXS",
    }),
    //打开询盘 点击索取样品
    openInquiry(item) {
      console.log(item);
      this.$store.commit("company/setExhibitorId", item.exhibitorId);
      this.$store.commit("company/setCompanyId", item.exhibitor.company.id);
      let exInfo = {
        compLogo: item.exhibitor.company.logo,
        compName: item.exhibitor.company.name,
        boothInfo: item.exhibitor.boothInfo,
      };
      this.$refs.inquiry.open(exInfo);
    },
    setSearch(e) {
      // 设置搜索值
      console.log(e, "设置搜索值");
      this.openSearch = false;
      // this.searchText = e.txt;
      // this.searchType = e.type;  // 0为输入搜索，1为展馆，2为类别
    },
    goLinkExInvitation(exhibitorId, exhibitionId) {
      let opt = {
        exhibitorId: exhibitorId,
        exhibitionId: exhibitionId,
      };
      this.LinkExInvitation(opt);
    },
    async init() {
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", exhibitionId);
      this.getBanner();
      await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, this.userId);
      await this.$Myapollo.getCategory(this, this.exhibitionId);
      this.navList = this.sortList(this.category);
      this.navList = this.getList(this.navList);
      this.navList.unshift({ id: "all", name: "All", nameEn: "All" });
      // console.log(this.navList,'navL');
      let arr = JSON.parse(JSON.stringify(this.navList));
      arr.shift();
      this.classOption = arr;
      this.areaOption = this.getRegionList(regionData);
      this.docTitle = this.exhibitionInfo.exhibition.nameEn || "Products";
      this.getProductList();
      // 分享的配置
      await this.getShareVal();
      const opt = {
        title: this.shareV.content ? this.shareV.content : "诚邀您参观 " + this.exhibitionInfo.exhibition.name + " 线上展",
        desc: this.shareV.des || this.exhibitionInfo.exhibition.remark,
        link: window.location.href,
        imgUrl: this.exhibitionInfo.exhibition.logo,
      };
      this.shareToWechat(opt);
    },
    //展会banner
    getBanner() {
      const query = gql`
        query banners($exhibitionId: Guid!) {
          banners(exhibitionId: $exhibitionId, position: "show.page.products.en") {
            content
            covers
            isShow
            url
            showIndex
          }
        }
      `;
      this.$apollo.addSmartQuery("banners", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          // console.log('请求回来了banners',res)
          let data = JSON.parse(JSON.stringify(res.data.banners));
          // let data=res.data.giveExInfo;
          if (data && data.length) {
            data.sort((a, b) => {
              return a.showIndex - b.showIndex;
            });
            this.titleBanner = data;
            this.allBanner = data;
          } else {
            this.titleBanner = [];
          }
          // console.log(this.titleBanner,'titileban')
          this.showDefaultBanner = true;
        },
        error(err) {},
      });
    },
    // 获取展会的分享配置
    async getShareVal() {
      let res = await this.getSettingShare({ id: this.exhibitionId, name: "share.exhibition.config" });
      if (res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    loadMore() {
      if (this.dataFinished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex, "当前加载的页面");
      this.getProductList();
    },
    async getProductList() {
      let query = `
        query getProduct(
          $exhibitionId: ID!
          $categories: [String]
          $regions: [String]
          $page: Int
          $size: Int
          $text: String
          $name: String
        ) {
          getProduct(
            query: {
              exhibitionId: $exhibitionId
              categories: $categories
              regions: $regions
              page: $page
              size: $size
              text: $text
              name: $name
            }
          ) {
            hasNextPage
            totalCount
            totalPages
            pageIndex
            items {
              id
              name
              nameEn
              banner
              category
              exhibitorId
              isPopularize
              panoramaUrl
              exhibitor {
                businesses(num: 3) {
                  isSample
                  remark
                }
                isLiving
                category
                boothInfo
                company {
                  id
                  name
                  nameEn
                  logo
                }
              }
              likes{
                userInfo
              }
              likeCount
              selling
              sellingEn
              newestEvaluates{
                content
              }
              video
              view3DUrl
              topicStart
              topicEnd
              topicType
              region
            }
          }
        }
      `;
      let opt = {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
          categories: this.options.categories,
          regions: this.options.regions,
          name: this.options.name,
          text: this.options.text,
          page: this.pageIndex,
          size: this.pageSize,
        },
      };
      let data = await this.graphqlPostByZXS(opt);
      console.log(data, "ssss");
      let res = JSON.parse(JSON.stringify(data.data.getProduct));
      res.items.map((el) => {
        if (el.topicType != "NORMAL") {
          // NORMAL 普通  ； RECOMMEND 推荐；TOP 置顶
          (el.showTop = "TOP"), (el.top = this.getRandomTop());
        }
        if (el.likes && el.likes.length) {
          el.likes.forEach((e) => {
            e.userInfo = JSON.parse(e.userInfo);
          });
        }
      });
      if (this.pageIndex == 1) {
        this.dataList = res.items;
      } else {
        this.dataList = [...this.dataList, ...res.items];
      }
      console.log(this.dataList, "产品");
      this.dataLoading = false;
      this.hasNextPage = res.hasNextPage;
      if (!res.hasNextPage) {
        this.dataFinished = true;
      }
    },
    sortList (arrJson) {
      console.log('排序前：', arrJson);
      let arr = JSON.parse(JSON.stringify(arrJson));
      arr.sort((a, b) => { return a.showIndex - b.showIndex });
      arr.map((c) => {
        c.type = 1;
        if (c.childrens && c.childrens.length) {
          c.childrens.sort((a, b) => { return a.showIndex - b.showIndex });
        }
        c.children = c.childrens && c.childrens.length ? c.childrens : [];
        if (c.children && c.children.length) {
          c.children.map(e => {
            e.type = c.type + 1;
            if (e.type === 1 || e.type === 2) {
              if (e.childrens && e.childrens.length) {
                e.childrens.sort((a, b) => { return a.showIndex - b.showIndex });
              }
              e.children = e.childrens && e.childrens.length ? e.childrens : [];
            }
          })
        }
      });
      console.log('排序后：', arr);
      return arr;
    },
    // 工具类
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getList(arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        if (arrJson) {
          arrJson.forEach((el) => {
            classArr.push({
              id: el.id,
              name: el.name,
              nameEn: el.nameEn,
              icon: el.icon,
              banners: el.banners,
              lists: this.getList(el.childrens, false),
            });
          });
        }
      } else {
        if (arrJson) {
          arrJson.forEach((el) => {
            classArr.push({
              id: el.id,
              name: el.name,
              nameEn: el.nameEn,
              icon: el.icon,
              banners: el.banners,
            });
          });
        }
      }
      return classArr;
    },
    getRegionList(arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        arrJson.forEach((el) => {
          classArr.push({
            id: el.id,
            name: el.name,
            nameEn: el.nameEn,
            icon: el.icon,
            lists: this.getList(el.lists, false),
          });
        });
      } else {
        arrJson.forEach((el) => {
          classArr.push({
            id: el.id,
            name: el.name,
            nameEn: el.nameEn,
            icon: el.icon,
          });
        });
      }
      return classArr;
    },
    getAllActiveState() {
      return this.isAreaAll.includes(true);
    },
    //随机获取top值 10-90
    getRandomTop() {
      return Math.random() * 70 + 10 + "%";
    },
    //工具类结束
    //数据加载 isLoad 是否list下拉触发的加载
    async dataLoad(isLoad = false) {
      if (!isLoad) {
        this.dataList = [];
        this.dataLoading = true; //打开加载状态
        this.dataFinished = false; //关闭加载结束
        this.pageIndex = 1;
      }
      // 初始化数据
      this.finished = false; //关闭加载结束
      this.options = {
        categories: [],
        regions: "",
        name: "",
        text: "",
      };
      let option = {};
      let leftActive = this.navList[this.activeKey];
      // 按类别搜索
      if (leftActive.id != "all") {
        if (!this.isClassAll && this.classVals.length > 0) {
          let len = this.classVals.length;
          for (let i = 0; i < len; i++) {
            // let cateName = this.getCateName(  // 根据类别的名称查
            //   leftActive.lists,
            //   this.classVals[i]
            // );
            let id = this.getCateId(
              // 根据类别的id查
              leftActive.lists,
              this.classVals[i]
            );
            this.options.categories.push(id);
          }
        } else {
          // this.options.categories.push(leftActive.name);
          this.options.categories.push(leftActive.id);
        }
      }

      //地区
      let areaIsAll = this.isAreaAll.every((item) => {
        return item;
      });
      if (!areaIsAll) {
        let diqu = [];
        for (let i = 0; i < this.isAreaAll.length; i++) {
          if (this.isAreaAll[i]) {
            diqu.push(this.areaOption[i].name);
          }
        }
        this.areaVals.forEach((e) => {
          diqu.push(this.getAreaName(e));
        });
        if (diqu.length) {
          option.regions = diqu;
        }
        console.log(diqu, "diqudiqu");
      }
      this.options.regions = option.regions;
      //console.log(diqu,'点击搜索的结果')
      this.getProductList();
    },
    getCateName(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
          return arr[i].name;
        }
      }
    },
    getCateId(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
          return arr[i].id;
        }
      }
    },
    //菜单改变 切换titlebanner
    changeTitleBanner(i) {
      // console.log(this.navList[i],'切换得菜单')
      let arr = this.navList[i].banners ? this.navList[i].banners.split(";") : [];
      let bannerArr = [];
      arr.forEach((e) => {
        let demo = {
          url: false,
          covers: e,
        };
        bannerArr.push(demo);
      });
      this.titleBanner = bannerArr.length ? JSON.parse(JSON.stringify(bannerArr)) : [];
    },
    //左侧菜单栏改变
    activeChange(index) {
      this.activeKey = index;
      this.$Myapollo.addExhibitionView();
      if (index) {
        this.classOption = this.getList(this.navList[index].lists, false);
        this.changeTitleBanner(index);
      } else {
        let arr = JSON.parse(JSON.stringify(this.navList));
        arr.shift();
        this.classOption = arr;
        this.titleBanner = JSON.parse(JSON.stringify(this.allBanner));
      }
      this.allClick();
      this.$nextTick(() => { 
        this.dataLoad();
      });
    },
    //右侧全部点击
    allClick(isdataLoad = false) {
      this.isClassAll = false;
      this.areaVals = [];
      this.classVals = [];
      this.isAreaAll = [false, false, false];
      this.$nextTick(() => {
        this.allActive = true;
      });
      this.areaShow = false;
      this.classShow = false;
      if (isdataLoad) {
        this.$Myapollo.addExhibitionView();
        // console.log('右侧全部点击')
        this.dataLoad();
      }
    },
    //类别下拉点击
    classClick() {
      this.areaShow = false;
      this.$nextTick(() => {
        this.classShow = !this.classShow;
      });
    },
    //类别全选
    classAllClick() {
      this.$Myapollo.addExhibitionView();
      // console.log('类别全选')
      this.isClassAll = !this.isClassAll;
      this.allActive = false;
      if (this.isClassAll) {
        this.classVals = [];
      }
      this.dataLoad();
    },
    //类别选择点击
    classChange(id) {
      for (let i = 1; i < this.navList.length; i++) {
        if (this.navList[i].id == id) {
          this.activeChange(i);
          return;
        }
      }
      this.$Myapollo.addExhibitionView();
      if (this.classVals.length > 0) {
        this.isClassAll = false;
        this.allActive = false;
      }
      // console.log('类别选择点击')
      this.dataLoad();
    },
    //类别弹出层挂载节点
    getDomPop() {
      return document.querySelector(".pop_block");
    },
    //地区下拉点击
    areaClick() {
      this.classShow = false;
      this.$nextTick(() => {
        this.areaShow = !this.areaShow;
      });
    },
    //地区单个点击  ind:索引 得到是第几个数组里的
    areaItemClick(ind) {
      this.$Myapollo.addExhibitionView();
      this.allActive = false;
      this.$set(this.isAreaAll, ind, false);

      this.$nextTick(() => {
        // console.log('地区单个点击')
        this.dataLoad();
      });
    },
    getAreaName(areaId) {
      // let newareaList=[]
      for (let i = 0; i < this.areaOption.length; i++) {
        let list = this.areaOption[i].lists;
        console.log(list, "indddddddddddddddddddddddd");
        for (let j = 0; j < list.length; j++) {
          if (areaId == list[j].id) {
            // newareaList.push(this.areaOption[i].name,list[j].name)
            // return  newareaList
            //
            // console.log(this.areaOption[i].name,list[j].name,'地区地区')
            //  this.newareaList.push(this.areaOption[i].name,list[j].name)
            // this.newareaList=Array.from(new Set(this.newareaList))
            // console.log(this.newareaList,'地区数组 地区数组')
            // return this.newareaList
            return `${this.areaOption[i].name}`, `${list[j].name}`;
          }
        }
      }
    },
    //地区全选点击    index:当前全选的索引  0 国际 1中国大陆 2港澳台
    areaAllClick(index) {
      this.$Myapollo.addExhibitionView();
      this.$set(this.isAreaAll, index, !this.isAreaAll[index]);
      if (this.isAreaAll[index]) {
        let indexArr = this.getList(this.areaOption[index].lists, false);
        let idarr = indexArr.map((el) => el.id); //得到当前index下id数组
        this.areaVals = this.areaVals.filter((v) => !idarr.includes(v)); //干掉地区选择数组里面的index下id数组  过滤
      }
      this.$nextTick(() => {
        // console.log('地区全选点击')
        this.dataLoad();
      });
    },
    goLinkProduct(id) {
      this.LinkProduct(id);
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes remindMessage {
  0% {
    transform: translateX(2.6rem);
  }
  100% {
    transform: translateX(-200%);
  }
}
@keyframes remindMessageShort {
  0% {
    transform: translateX(2.6rem);
  }
  100% {
    transform: translateX(-100%);
  }
}

.layout {
  padding-bottom: 55px;
  padding-top: 0.93rem;
}
.ex_select {
  height: 0.76rem;
  border: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  color: #000;
  padding-right: 0.22rem;
  .logo {
    width: 1.86rem;
    height: 0.66rem;
    border-radius: 32px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    opacity: 0.9;
    margin-left: 0.3rem;
    display: flex;
    align-items: center;
    img {
      width: 0.5rem;
      height: 0.5rem;
      background-color: #f54a62;
      border-radius: 50%;
      margin-left: 0.12rem;
    }
    span {
      font-size: 0.22rem;
      margin-left: 0.12rem;
    }
  }
  &-input {
    width: 3.3rem;
    height: 0.48rem;
    background-color: #f3f3f3;
    border-radius: 24px;
    display: flex;
    align-items: center;
    margin-left: 0.24rem;
    input::-webkit-input-placeholder {
      color: #bfbfbf;
    }
    input {
      width: 2.3rem;
      height: 0.48rem;
      background-color: #f3f3f3;
      border-width: 0px;
      margin-left: 0.14rem;
    }
  }
  &-right1 {
    width: 0.44rem;
    margin-left: 0.3rem;
    img {
      height: 0.46rem;
    }
  }
  &-right2 {
    width: 0.44rem;
    margin-left: 0.3rem;
    img {
      height: 0.46rem;
    }
  }
}
.ex_page {
  // display: flex;
  height: 100vh;
  position: fixed;
  left: 0;
  right: 0;
  padding-right: 0.22rem;
  /*background: #131825;*/
  background: #fff;
  .ex_left {
    width: 1.9rem;
    flex-shrink: 0;
    min-height: 100%;
    margin-right: 0.24rem;
    overflow: hidden;
    /*background: none repeat scroll 0 0 #1d2435;*/
    background-color: #f2f2f2;
    position: absolute;
    top: 0;
    bottom: 1rem;
    left: 0;
    z-index: 999;
    .active_wrap {
      width: 100%;
      height: calc(100% - 1.93rem);
      // overflow-y: auto;
      .active_list {
        width: 100%;
        height: 100%;
        overflow: auto;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        // &::after{
        //   content: '';
        //   display: block;
        //   height:calc();
        //   width: 100%;
        // }
        .active_item {
          /*background: #1d2435;*/
          background: #f2f2f2;
          color: #666;
          padding: 0.3rem 0.05rem;
          line-height: 1.1;
          overflow: hidden;
          text-align: center;
          word-wrap: break-word;
          cursor: pointer;
          user-select: none;
          border-left: 2px solid transparent;
          // display: -webkit-box;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // -webkit-line-clamp: 3;
          // -webkit-box-orient: vertical;
          &.is_active {
            background: #fff;
            border-left: 4px solid #0190fe;
          }
          span {
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            // word-break: break-all;
          }
        }
      }
    }
  }
  .ex_right {
    position: absolute;
    right: 0.22rem;
    left: 2.14rem;
    flex-shrink: 1;
    padding-top: 0.2rem;
    .title {
      margin-bottom: 0.2rem;
      border-radius: 0.07rem;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      height: 1.2rem;
      width: 100%;
      background: #fff;
      position: relative;
      .pro_title_swipe {
        width: 100%;
        height: 100%;
        .van-swipe-item {
          width: 100%;
          height: 100%;
          position: relative;
          a {
            width: 100%;
            height: 100%;
          }
        }
      }
      img {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
      p {
        font-size: 0.3rem;
        position: relative;
        z-index: 2;
      }
    }
    .type_nav {
      display: flex;
      justify-content: space-between;
      position: relative;
      margin-bottom: 0.3rem;
      &::v-deep .pop_overlay {
        left: 0;
        top: 0;
        position: absolute;
        background-color: transparent;
      }
      .all_btn,
      .dropdownbtn {
        height: 0.54rem;
        padding: 0.14rem 0;
        // width: 1.6rem;
        width: 1.54rem;
        font-size: 0.24rem;
        border-radius: 0.06rem;
        border: none;
        color: #666;
        overflow: hidden;
        background: #f2f2f2;
        line-height: 1;
        position: relative;
        z-index: 1900;
        span {
          //width: 0.7rem;
          display: inline-block;
        }
        &.xiala {
          overflow: initial;
          background: #fff;
          border: 1px solid #0190fe;
          // transition: opacity  0;
          &::before {
            background: #fff;
            border-color: #fff;
            display: inline-block;
            width: 0.7rem;
          }
          > span {
            color: #0190fe;
            display: inline-block;
            // width: 0.7rem;
            &::after {
              margin-top: -1px;
              -webkit-transform: rotate(135deg);
              transform: rotate(135deg);
            }
          }
          &::after {
            content: "";
            position: absolute;
            height: 0.3rem;
            bottom: -0.2rem;
            left: 0;
            right: 0;
          }
        }
        &::after {
          border-color: #1d2435;
        }
        &.is_active {
          color: #1890ff;
          background: rgba(#1890ff, 0.1);
          span {
            width: 1.2rem;
          }
        }
        &:first-child.is_active {
          color: #fff;
          background: #0190fe;
        }
      }
      &::v-deep .dropdownbtn {
        span {
          padding: 0 0.08rem;
          position: relative;
          left: -0.2rem;
          //width: 0.7rem;
          &::after {
            position: absolute;
            top: 50%;
            right: -0.25rem;
            margin-top: -5px;
            border: 3px solid;
            border-color: transparent transparent currentColor currentColor;
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
            opacity: 0.8;
            content: "";
          }
        }
        &.is_active {
          > span {
            color: #0190fe;
            width: 1.2rem;
          }
        }
      }
      .pop_block {
        position: fixed;
        right: 0;
        left: 1.9rem;
        top: 3.1rem;
        bottom: 0;
        overflow: hidden;
        z-index: 2000;
      }
      .pop_mask {
        z-index: 1000;
        position: fixed;
        left: 2.14rem;
        right: 0;
        top: 0;
        bottom: 0;
      }
      &::v-deep .drop_pop {
        right: 0;
        left: 0;
        top: 0;
        width: auto;
        height: 5.2rem;
        background: #fff;
        padding: 0.2rem 0.25rem;
        position: absolute;
        z-index: 3001 !important;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
        .class_con {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          .class_item {
            height: 0.64rem;
            padding: 0 0 0 0.2rem;
            line-height: 0.64rem;
            margin-bottom: 0.12rem;
            border-radius: 0.08rem;
            color: #666;
            background: #f2f2f2;
            &[aria-checked="true"],
            &.is_active {
              background: #d9eeff;
              color: #0190fe;
              .van-checkbox__label {
                color: #0190fe;
                font-size: 0.24rem;
                line-height: initial;
                margin-left: 0;
              }
            }
            .van-checkbox__icon {
              display: none;
            }
            .van-checkbox__label {
              color: #666;
              font-size: 0.24rem;
              line-height: initial;
              margin-left: 0;
              &:after {
                color: #0190fe;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
            &.is-active {
              background: #f85b0f;
            }
          }
        }

        .area_con {
          margin-top: 0.07rem;
          color: #fff;
          &:nth-child(1) {
            margin-top: 0.1rem;
          }
          p {
            color: #666;
            line-height: 1;
            margin-bottom: 0.1rem;
          }
          .area_item_warp {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &::after {
              content: "";
              width: 30%;
              border: 1px solid transparent;
            }
            .area_item {
              display: block;
              padding: 0 0.13rem;
              margin-bottom: 0.12rem;
              width: 2.14rem;
              height: 0.64rem;
              line-height: 0.64rem;
              text-align: center;
              border-radius: 0.08rem;
              color: #666;
              background: #f2f2f2;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &[aria-checked="true"],
              &.is_active {
                background: #d9eeff;
                color: #0190fe;
                .van-checkbox__label {
                  color: #0190fe;
                }
              }
              .van-checkbox__icon {
                display: none;
              }
              .van-checkbox__label {
                color: #666;
                font-size: 0.24rem;
                line-height: initial;
                margin-left: 0;
              }
              &.is-active {
                background: #f85b0f;
              }
              .van-checkbox__label {
                color: #666;
              }
            }
          }
        }
      }
    }
    &::v-deep .ex_content {
      position: fixed;
      top: 3.12rem;
      left: 2.14rem;
      right: 0.24rem;
      bottom: 0;
      overflow: auto;
      padding-bottom: 0.98rem;
      .ex_con_wrap {
        // margin-top: 0.3rem;
        .ex_item {
          &:first-child {
            padding-top: 0.25rem;
          }
          background: #fff;
          position: relative;
          padding: 0.3rem 0;
          border-bottom: solid 1px #f4f4f4;
          display: flex;
          .img_div {
            width: 1.6rem;
            height: 1.6rem;
            margin-right: 0.2rem;
            display: block;
            flex-shrink: 0;
            // border: solid 1px #dce4ec;
            position: relative;
            .play_video {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.2);
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                font-size: 0.72rem;
                color: #fff;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
            .img-d {
              width: 0.6rem;
              height: 0.26rem;
              background-color: #fff;
              border-radius: 0px 0px 0px 0.1rem;
              border: solid 1px #ff5c00;
              color: #ff5c00;
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              span {
                font-size: 0.16rem;
              }
            }
            .img-v {
              width: 0.38rem;
              background-color: #fff;
              border: solid 1px #0190fe;
              color: #0190fe;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                font-size: 0.16rem;
              }
            }
          }
          .pro_info {
            max-width: calc(100% - 1.8rem);
            .pro_title {
              display: flex;
              margin-top: -0.05rem;
              align-items: center;
              p {
                font-size: 0.26rem;
                color: #333;
                font-weight: bold;
                min-height: 0.3rem;
              }
              .is_live {
                width: 0.88rem;
                height: 0.3rem;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                color: #fff;
                margin-left: 0.15rem;
                background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%), linear-gradient(#000, #000);
                background-blend-mode: normal, normal;
                border-radius: 0.05rem;
                color: #fff;
                font-size: 0.18rem;
                // vertical-align: middle;
                span {
                  display: block;
                  height: 0.12rem;
                  width: 0.12rem;
                  margin-right: 0.06rem;
                  border-radius: 50%;
                  background: #fff;
                }
              }
              .is_hot {
                background: #ff5c00;
              }
            }
            .comp_name {
              font-size: 0.22rem;
              color: #333;
              margin-top: 0.08rem;
            }
            .selling {
              margin-top: 0.1rem;
              font-size: 0.2rem;
              color: #999;
            }
            .bus {
              display: flex;
              align-items: center;
              margin-right: 0.2rem;
              margin-top: 0.14rem;
              height: 0.36rem;
              border-radius: 0.05rem;
              color: #666;
              p {
                font-size: 0.2rem;
                padding: 0 0.1rem;
                background: #eef8ff;
                &.is_sa {
                  padding-right: 0;
                }
              }
              span {
                padding-right: 0.1rem;
                flex-shrink: 0;
                padding-left: 0.2rem;
                background: #eef8ff;
                color: #199bff;
                text-decoration: underline;
                font-size: 0.2rem;
              }
            }
            .eval {
              margin-top: 0.14rem;
              padding: 0.08rem 0.1rem;
              font-size: 0.2rem;
              background: #f2f2f2;
              color: #666;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              span {
                font-size: 0.2rem;
                color: #999;
              }
            }
            .likes_div {
              display: flex;
              margin-top: 0.24rem;
              align-items: center;
              .avatar_img {
                flex-shrink: 0;
                display: flex;
                div {
                  width: 0.31rem;
                  height: 0.31rem;
                  position: relative;
                  left: -0.15rem;
                  z-index: 1;
                  &:nth-child(1) {
                    left: 0;
                    z-index: 3;
                  }
                  &:nth-child(2) {
                    z-index: 2;
                  }
                  &:nth-child(3) {
                    left: -0.3rem;
                  }
                  .img {
                    display: block;
                    border: 1px solid #fff;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                  }
                }
              }
              p {
                font-size: 0.2rem;
                color: #999;
                &.ava_count3 {
                  margin-left: -0.2rem;
                }
                &.ava_count2 {
                  margin-left: -0.05rem;
                }
                &.ava_count1 {
                  margin-left: 0.1rem;
                }
              }
            }
          }
        }
      }
      .van-list__finished-text,
      .van-list__loading {
        line-height: 0.3rem;
        margin: 0.45rem auto 0.15rem;
        font-size: 0.24rem;
      }
    }
  }
}

.f-tac {
  text-align: center;
  color: #969799;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
